export default class ApiService {
  constructor() {
    this.baseUrl = "/api/ministry_scales/members";
    this.csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");
  }

  createMember(data) {
    return $.ajax({
      url: this.baseUrl,
      type: "POST",
      dataType: "json",
      contentType: "application/json",
      headers: {
        "X-CSRF-Token": this.csrfToken,
      },
      data: JSON.stringify(data),
    });
  }

  updateMember(data) {
    const id = data.id;
    delete data.id;

    return $.ajax({
      url: `${this.baseUrl}/${id}`,
      type: "PATCH",
      dataType: "json",
      contentType: "application/json",
      headers: {
        "X-CSRF-Token": this.csrfToken,
      },
      data: JSON.stringify(data),
    });
  }

  deleteMember(id) {
    return $.ajax({
      url: `${this.baseUrl}/${id}`,
      type: "DELETE",
      headers: {
        "X-CSRF-Token": this.csrfToken,
      },
    });
  }
}
